module.exports = __webpack_public_path__ + "static/media/2122-service-2-5-min.3946ba56.jpg";